<template>
  <a
    class="button"
    :class="{
      'button-primary': color === 'green', // v2: green CTA → brand-green primary (was mint button-green-branding-fix)
      'button-black': color === 'black',
      'button-accent': color === 'yellow', // v2 (V27): the 'yellow' highlight CTA → gold Accent (one per view)
      'button-white': color === 'white',
      'mb-wp-100': fullWidthMobile,
    }"
    :href="sendMail ? mailTo : goToGroupDesign"
    target="_blank"
  >
    {{ title }}
    <img
      v-if="shouldShowicon"
      class="ml-8 w-17"
      :src="`${ASSETS_CDN}/icons/arrow_outward.svg`"
      alt="arrow outward"
    />
  </a>
</template>

<script setup>
import {assetCDN} from '~/helper/index.js'
import { computed } from 'vue'
import { SCHOOL_TOUR_ROUTE } from '~/constant/common.js'
import { useRoute } from 'vue-router'
import { SCHOOL_CONTACT_LINK } from '~/constant/schoolTourDetails'

// eslint-disable-next-line no-undef
defineProps({
  title: {
    type: String,
    default: 'Start Designing Now',
  },
  color: {
    type: String,
    default: 'green',
  },
  fullWidthMobile: {
    type: Boolean,
    default: true,
  },
  sendMail: {
    type: Boolean,
    default: false,
  },
  shouldShowicon: {
    type: Boolean,
    default: true,
  },
})

const ASSETS_CDN = assetCDN()
const route = useRoute()

const goToGroupDesign = computed(() => {
  if(route.name === SCHOOL_TOUR_ROUTE.name) return `${SCHOOL_CONTACT_LINK}`
  return `${useAppConfig().publicDomainAgent}/design/group-trip-details`
})

const mailTo = computed(() => {
  if(route.name === SCHOOL_TOUR_ROUTE.name) return `${SCHOOL_CONTACT_LINK}`
  return `mailto:travel@designerjourneys.com`
})
</script>

<style lang="scss" scoped>
a:link,
a:visited,
a:hover,
a:active,
a:focus {
  color: unset;
}

.button-primary {
  // beat the `a { color: unset }` reset above so the green CTA keeps its white v2 label
  &:link,
  &:visited,
  &:hover,
  &:active,
  &:focus {
    color: $white;
  }
  // v2 dark mode (Wave 7/V31, G10) — this scoped rule out-specifies the global
  // [data-theme="dark"] .button-primary label-flip, so re-assert the black label on the
  // green fill here (else the CTA stays white-on-green in dark).
  [data-theme='dark'] & {
    &,
    &:link,
    &:visited,
    &:hover,
    &:active,
    &:focus {
      color: $ink;
    }
  }
}

.button-black {
  &:link,
  &:visited,
  &:hover,
  &:active,
  &:focus {
    color: #fff;
  }

  img {
    filter: invert(96%) sepia(98%) saturate(7%) hue-rotate(160deg)
      brightness(104%) contrast(101%);
  }
}

.button-white {
  border-radius: $radius-pill;
}
</style>
